export class Timeouts {
    /**
     * Default timeout for all Common App SDK method
     * @static
     * @type {number}
     * @memberof Timeouts
     */
    static SdkGlobal: number = 2 * 60 * 1000;
}
